import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Content.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import { API } from '../backend';
import { ThreeDots } from 'react-loading-icons'
import Loading from '../loading/loading';

const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};


const Content = ({ fromMyCourse }) => {
  const [courses, setCourses] = useState([]);
  const [visibleChunks, setVisibleChunks] = useState(2);
  const navigate = useNavigate();
  const [chunkSize, setChunkSize] = useState(3);
  const contentContainerRef = useRef(null);
  const contentContainerMobileRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setIsLoading(true);
        const token = Cookies.get('token');

        const headers = token ? { Authorization: `Token ${token}` } : {};

        const watched_courses = fromMyCourse ? true : false;

        const response = await axios.get(`${API}api/v1/course/?watched_courses=${watched_courses}`, { headers });
        setCourses(response.data);
      } catch (error) {
        console.error('Error fetching courses:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourses();
  }, [fromMyCourse]);
  
  useEffect(() => {
    const checkVisibility = () => {
      if (contentContainerRef.current && window.getComputedStyle(contentContainerRef.current).display !== "none") {
        setChunkSize(3);
      } else if (contentContainerMobileRef.current && window.getComputedStyle(contentContainerMobileRef.current).display !== "none") {
        setChunkSize(1);
      }
    };

    checkVisibility();
    window.addEventListener("resize", checkVisibility);
    
    return () => {
      window.removeEventListener("resize", checkVisibility);
    };
  }, []);

  const stepChunks = chunkArray(courses, chunkSize);

  // Function to load more chunks (each chunk contains 3 courses)
  const loadMore = () => {
    setVisibleChunks((prevChunks) => prevChunks + 1); // Load 2 more chunks (6 courses) per click
  };

  const handleContentClick = (contenteId) => {
    navigate("/course", { state: { contenteId } });
  };



  return (   
    <>
    <div ref={contentContainerRef} className='content-container'>
      {!fromMyCourse ? (
        <p className='content_title'>راحت ترین راه آموزش و یادگیری ارزمجازی</p>
      ) : (
        <div className='mycourse-content'>
          <p className='content_title-mycourse'>دوره های مشاهده شده</p>
        </div>
      )}
      {isLoading ? (
          <div className='content-wrapper'>
            <div className='loading-placeholder'>
                <Loading/>
            </div>
          </div>
      ) : (
      stepChunks.slice(0, visibleChunks).map((chunk, index) => (
        <div className='content-wrapper' key={index}>
          {chunk.map((course, index) => (
            <div className='content_steps' key={index} onClick={() => handleContentClick(course.id)}>
                <div className='content_image'>
                  <img src={course.image || require('../images/content_image.png')} alt={course.title} className="content-course-image" />
                </div>
                <div className='content_description'>
                    <div className='content-text-wrapper'>
                      <p className='description_title'>{course.title}</p>
                      <p className='description_text'>{course.description}</p>
                    </div>
                    <div className='content_tags'>
                    <button className={`content-btn ${fromMyCourse && course.quiz_gift_token_total === course.total_gift_token ? 'green-btn-content' : ''}`}>
                      {fromMyCourse ? (
                        course.quiz_gift_token_total === course.total_gift_token ? (
                          <> {course.total_gift_token} توکن این دوره را دریافت نموده اید </>
                        ) : (
                          <> {course.quiz_gift_token_total} از {course.total_gift_token} توکن را دریافت نموده اید </>
                        )
                      ) : (
                        <> {course.total_gift_token} توکن ایوا کسب کن </>
                      )}
                    </button>
                        <p className='content_time_section'>
                          {!fromMyCourse ? (
                          <>
                          <svg className="time-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7.99996" cy="8.00008" r="6" stroke="#33363F" stroke-width="1.33333" />
                            <path d="M11 8.00008H8.16667C8.07462 8.00008 8 7.92546 8 7.83341V5.66675" stroke="#33363F" stroke-width="1.33333" stroke-linecap="round" />
                          </svg>
                          {course.total_duration}
                          </>
                          ) :
                          (
                            null
                          )}
                          </p>
                        <p className='content_time_section'>
                        <svg className='time-icon' viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.33341 10.6667H10.6667C11.9238 10.6667 12.5524 10.6667 12.9429 10.2761C13.3334 9.88562 13.3334 9.25708 13.3334 8V4.66667C13.3334 3.40959 13.3334 2.78105 12.9429 2.39052C12.5524 2 11.9238 2 10.6667 2H5.33341C4.07634 2 3.4478 2 3.05727 2.39052C2.66675 2.78105 2.66675 3.40959 2.66675 4.66667V12.3333C2.66675 11.4129 3.41294 10.6667 4.33341 10.6667ZM6.00012 4C5.26374 4 4.66679 4.59695 4.66679 5.33333C4.66679 6.06971 5.26374 6.66667 6.00012 6.66667H10.0001C10.7365 6.66667 11.3335 6.06971 11.3335 5.33333C11.3335 4.59695 10.7365 4 10.0001 4L6.00012 4Z" fill="#222222"/>
                          <path d="M12.9429 10.2761L12.4715 9.80474L12.4715 9.80474L12.9429 10.2761ZM12.9429 2.39052L12.4715 2.86193L12.4715 2.86193L12.9429 2.39052ZM4.66679 5.33333L5.33346 5.33333V5.33333H4.66679ZM6.00012 4L6.00012 3.33333H6.00012V4ZM10.0001 6.66667L10.0001 6H10.0001V6.66667ZM10.0001 4L10.0001 4.66667H10.0001V4ZM10.6667 10H4.33341V11.3333H10.6667V10ZM12.4715 9.80474C12.4207 9.85549 12.3301 9.91825 12.0409 9.95713C11.7326 9.99858 11.3141 10 10.6667 10V11.3333C11.2764 11.3333 11.8008 11.3347 12.2186 11.2786C12.6556 11.2198 13.0745 11.0873 13.4143 10.7475L12.4715 9.80474ZM12.6667 8C12.6667 8.64739 12.6653 9.06586 12.6239 9.3742C12.585 9.66336 12.5222 9.75399 12.4715 9.80474L13.4143 10.7475C13.7541 10.4078 13.8866 9.98887 13.9453 9.55186C14.0015 9.13403 14.0001 8.60969 14.0001 8H12.6667ZM12.6667 4.66667V8H14.0001V4.66667H12.6667ZM12.4715 2.86193C12.5222 2.91268 12.585 3.00331 12.6239 3.29247C12.6653 3.60081 12.6667 4.01928 12.6667 4.66667H14.0001C14.0001 4.05697 14.0015 3.53264 13.9453 3.11481C13.8866 2.67779 13.7541 2.25889 13.4143 1.91912L12.4715 2.86193ZM10.6667 2.66667C11.3141 2.66667 11.7326 2.66808 12.0409 2.70954C12.3301 2.74841 12.4207 2.81118 12.4715 2.86193L13.4143 1.91912C13.0745 1.57935 12.6556 1.44685 12.2186 1.38809C11.8008 1.33192 11.2764 1.33333 10.6667 1.33333V2.66667ZM5.33341 2.66667H10.6667V1.33333H5.33341V2.66667ZM3.52868 2.86193C3.57943 2.81118 3.67006 2.74841 3.95922 2.70954C4.26755 2.66808 4.68603 2.66667 5.33341 2.66667V1.33333C4.72372 1.33333 4.19939 1.33192 3.78155 1.38809C3.34454 1.44685 2.92564 1.57934 2.58587 1.91912L3.52868 2.86193ZM3.33341 4.66667C3.33341 4.01928 3.33483 3.60081 3.37629 3.29247C3.41516 3.00331 3.47793 2.91268 3.52868 2.86193L2.58587 1.91912C2.24609 2.25889 2.1136 2.67779 2.05484 3.11481C1.99867 3.53264 2.00008 4.05697 2.00008 4.66667H3.33341ZM3.33341 12.3333V4.66667H2.00008V12.3333H3.33341ZM4.33341 10C3.04475 10 2.00008 11.0447 2.00008 12.3333H3.33341C3.33341 11.781 3.78113 11.3333 4.33341 11.3333V10ZM5.33346 5.33333C5.33346 4.96514 5.63193 4.66667 6.00012 4.66667V3.33333C4.89555 3.33333 4.00012 4.22876 4.00012 5.33333H5.33346ZM6.00012 6C5.63193 6 5.33346 5.70152 5.33346 5.33333L4.00012 5.33333C4.00012 6.4379 4.89555 7.33333 6.00012 7.33333V6ZM10.0001 6H6.00012V7.33333H10.0001V6ZM10.6668 5.33333C10.6668 5.70152 10.3683 6 10.0001 6L10.0001 7.33333C11.1047 7.33333 12.0001 6.4379 12.0001 5.33333H10.6668ZM10.0001 4.66667C10.3683 4.66667 10.6668 4.96514 10.6668 5.33333H12.0001C12.0001 4.22876 11.1047 3.33333 10.0001 3.33333V4.66667ZM6.00012 4.66667L10.0001 4.66667L10.0001 3.33333L6.00012 3.33333L6.00012 4.66667ZM7.33342 13.3333H4.33341V14.6667H7.33342V13.3333ZM2.00008 12.3333C2.00008 13.622 3.04475 14.6667 4.33341 14.6667V13.3333C3.78113 13.3333 3.33341 12.8856 3.33341 12.3333H2.00008Z" fill="#222222"/>
                          <path d="M13.3334 14H6.66675" stroke="#222222" stroke-width="1.33333" stroke-linecap="round"/>
                        </svg>

                          {fromMyCourse ? (
                            <>{course.watched_section_count} از {course.section_count}</>
                          ) : (
                            <>{course.section_count} درس</>
                          )}
                        </p>
                    </div>
                </div>
            </div>
          ))}
        </div>
        ))
      )}
      {visibleChunks < stepChunks.length ? (
        <>
          <div className="load-more-container">
            <div className="load-more-line left"></div>
            <button className="load-more-text" onClick={loadMore}>
              <p className='load-more-text-p'>مشاهده بیشتر</p>
            </button>
            <div className="load-more-line right"></div>
          </div>
        </>
      ) : <div className='space-between-footer'></div>}
    </div>

    <div ref={contentContainerMobileRef} className='content-container-mobile'>
      
      {!fromMyCourse ? (
          <>
          <div className='margin-top-content-mobile'></div>
          <p className='content-title-mobile'>راحت ترین راه آموزش و یادگیری ارزمجازی</p>
          </>
      ) : (
          <div className='mycourse-content-mobile'>
            <p className='content_title-mycourse-mobile'>دوره های مشاهده شده</p>
          </div>
      )}

        {isLoading ? (
            <div className='content-wrapper-mobile'>
              <div className='loading-placeholder'>
                  <Loading/>
              </div>
            </div>
        ) : (
        stepChunks.slice(0, visibleChunks).map((chunk, index) => (
          <div className='content-wrapper-mobile' key={index}>
            {chunk.map((course, index) => (
              <div className='content_steps-mobile' key={index} onClick={() => handleContentClick(course.id)}>
                  <div className='content_image'>
                    <img src={course.image || require('../images/content_image.png')} alt={course.title} className="content-course-image" />
                  </div>
                  <div className='content_description'>
                      <div className='content-text-wrapper'>
                        <p className='description_title_mobile'>{course.title}</p>
                        <p className='description_text_mobile'>{course.description}</p>
                      </div>
                      <div className='content_tags'>
                      <button className={`content-btn-mobile ${fromMyCourse && course.quiz_gift_token_total === course.total_gift_token ? 'green-btn-content' : ''}`}>
                        {fromMyCourse ? (
                          course.quiz_gift_token_total === course.total_gift_token ? (
                            <> {course.total_gift_token} توکن این دوره را دریافت نموده اید </>
                          ) : (
                            <> {course.quiz_gift_token_total} از {course.total_gift_token} توکن را دریافت نموده اید </>
                          )
                        ) : (
                          <> {course.total_gift_token} توکن ایوا کسب کن </>
                        )}
                      </button>
                          <p className='content_time_section_mobile'>
                            {!fromMyCourse ? (
                            <>
                            <svg className="time-icon-mobile" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="7.99996" cy="8.00008" r="6" stroke="#33363F" stroke-width="1.33333" />
                              <path d="M11 8.00008H8.16667C8.07462 8.00008 8 7.92546 8 7.83341V5.66675" stroke="#33363F" stroke-width="1.33333" stroke-linecap="round" />
                            </svg>
                            {course.total_duration}
                            </>
                            ) :
                            (
                              null
                            )}
                            </p>
                          <p className='content_time_section_mobile'>
                          <svg className='time-icon-mobile' viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.33341 10.6667H10.6667C11.9238 10.6667 12.5524 10.6667 12.9429 10.2761C13.3334 9.88562 13.3334 9.25708 13.3334 8V4.66667C13.3334 3.40959 13.3334 2.78105 12.9429 2.39052C12.5524 2 11.9238 2 10.6667 2H5.33341C4.07634 2 3.4478 2 3.05727 2.39052C2.66675 2.78105 2.66675 3.40959 2.66675 4.66667V12.3333C2.66675 11.4129 3.41294 10.6667 4.33341 10.6667ZM6.00012 4C5.26374 4 4.66679 4.59695 4.66679 5.33333C4.66679 6.06971 5.26374 6.66667 6.00012 6.66667H10.0001C10.7365 6.66667 11.3335 6.06971 11.3335 5.33333C11.3335 4.59695 10.7365 4 10.0001 4L6.00012 4Z" fill="#222222"/>
                            <path d="M12.9429 10.2761L12.4715 9.80474L12.4715 9.80474L12.9429 10.2761ZM12.9429 2.39052L12.4715 2.86193L12.4715 2.86193L12.9429 2.39052ZM4.66679 5.33333L5.33346 5.33333V5.33333H4.66679ZM6.00012 4L6.00012 3.33333H6.00012V4ZM10.0001 6.66667L10.0001 6H10.0001V6.66667ZM10.0001 4L10.0001 4.66667H10.0001V4ZM10.6667 10H4.33341V11.3333H10.6667V10ZM12.4715 9.80474C12.4207 9.85549 12.3301 9.91825 12.0409 9.95713C11.7326 9.99858 11.3141 10 10.6667 10V11.3333C11.2764 11.3333 11.8008 11.3347 12.2186 11.2786C12.6556 11.2198 13.0745 11.0873 13.4143 10.7475L12.4715 9.80474ZM12.6667 8C12.6667 8.64739 12.6653 9.06586 12.6239 9.3742C12.585 9.66336 12.5222 9.75399 12.4715 9.80474L13.4143 10.7475C13.7541 10.4078 13.8866 9.98887 13.9453 9.55186C14.0015 9.13403 14.0001 8.60969 14.0001 8H12.6667ZM12.6667 4.66667V8H14.0001V4.66667H12.6667ZM12.4715 2.86193C12.5222 2.91268 12.585 3.00331 12.6239 3.29247C12.6653 3.60081 12.6667 4.01928 12.6667 4.66667H14.0001C14.0001 4.05697 14.0015 3.53264 13.9453 3.11481C13.8866 2.67779 13.7541 2.25889 13.4143 1.91912L12.4715 2.86193ZM10.6667 2.66667C11.3141 2.66667 11.7326 2.66808 12.0409 2.70954C12.3301 2.74841 12.4207 2.81118 12.4715 2.86193L13.4143 1.91912C13.0745 1.57935 12.6556 1.44685 12.2186 1.38809C11.8008 1.33192 11.2764 1.33333 10.6667 1.33333V2.66667ZM5.33341 2.66667H10.6667V1.33333H5.33341V2.66667ZM3.52868 2.86193C3.57943 2.81118 3.67006 2.74841 3.95922 2.70954C4.26755 2.66808 4.68603 2.66667 5.33341 2.66667V1.33333C4.72372 1.33333 4.19939 1.33192 3.78155 1.38809C3.34454 1.44685 2.92564 1.57934 2.58587 1.91912L3.52868 2.86193ZM3.33341 4.66667C3.33341 4.01928 3.33483 3.60081 3.37629 3.29247C3.41516 3.00331 3.47793 2.91268 3.52868 2.86193L2.58587 1.91912C2.24609 2.25889 2.1136 2.67779 2.05484 3.11481C1.99867 3.53264 2.00008 4.05697 2.00008 4.66667H3.33341ZM3.33341 12.3333V4.66667H2.00008V12.3333H3.33341ZM4.33341 10C3.04475 10 2.00008 11.0447 2.00008 12.3333H3.33341C3.33341 11.781 3.78113 11.3333 4.33341 11.3333V10ZM5.33346 5.33333C5.33346 4.96514 5.63193 4.66667 6.00012 4.66667V3.33333C4.89555 3.33333 4.00012 4.22876 4.00012 5.33333H5.33346ZM6.00012 6C5.63193 6 5.33346 5.70152 5.33346 5.33333L4.00012 5.33333C4.00012 6.4379 4.89555 7.33333 6.00012 7.33333V6ZM10.0001 6H6.00012V7.33333H10.0001V6ZM10.6668 5.33333C10.6668 5.70152 10.3683 6 10.0001 6L10.0001 7.33333C11.1047 7.33333 12.0001 6.4379 12.0001 5.33333H10.6668ZM10.0001 4.66667C10.3683 4.66667 10.6668 4.96514 10.6668 5.33333H12.0001C12.0001 4.22876 11.1047 3.33333 10.0001 3.33333V4.66667ZM6.00012 4.66667L10.0001 4.66667L10.0001 3.33333L6.00012 3.33333L6.00012 4.66667ZM7.33342 13.3333H4.33341V14.6667H7.33342V13.3333ZM2.00008 12.3333C2.00008 13.622 3.04475 14.6667 4.33341 14.6667V13.3333C3.78113 13.3333 3.33341 12.8856 3.33341 12.3333H2.00008Z" fill="#222222"/>
                            <path d="M13.3334 14H6.66675" stroke="#222222" stroke-width="1.33333" stroke-linecap="round"/>
                          </svg>

                            {fromMyCourse ? (
                              <>{course.watched_section_count} از {course.section_count}</>
                            ) : (
                              <>{course.section_count} درس</>
                            )}
                          </p>
                      </div>
                  </div>
              </div>
            ))}
          </div>
          ))
        )}
        {visibleChunks < stepChunks.length ? (
        <>
          <div className="load-more-container">
            <div className="load-more-line left"></div>
            <button className="load-more-text" onClick={loadMore}>
              <p className='load-more-text-p'>مشاهده بیشتر</p>
            </button>
            <div className="load-more-line right"></div>
          </div>
        </>
        ) : <div className='space-between-footer'></div>}
      </div>
    </>
  );
};

export default Content;
